export enum userType {
  human = "human",
  ai = "ai",
}

export enum streamErrorTypes {
  UserInterrupt = "UserInterrupt",
}

export enum streamEventType {
  metadata = "metadata",
  error = "error",
  updates = "updates",
  custom = "custom",
  chatModelStream = "on_chat_model_stream",
  end = "end",
}

// Generic field structure for dynamic configurations
interface InterruptField {
  type: string;
  required: boolean;
  value: any;
  selected_data: any[];
}

// Generic configuration type with dynamic field names
export interface InterruptType {
  action: string;
  fields: Record<string, InterruptField>;
  additional_kwargs?: Record<string, any>;
}

interface FieldType<ValueType, SelectedValueType> {
  type: string;
  required: boolean;
  value?: ValueType;
  selected_data: SelectedValueType;
}

export interface DBTGithubConfigData {
  github_dbt_folder_link: FieldType<string, null>;
  github_pat: FieldType<string, null>;
  data_limit: FieldType<number, null>;
}

// Additional kwargs types for each form
export interface DBTQuerySelectionKwargs {
  dbt_sources: string;
  suggested_models?: Array<Record<string, string>>;
}

export interface DBTCommitModelsKwargs {
  sql: string;
  summary: string;
  resulted_transformation: any[];
}

export interface DBTQuerySelectionData {
  query_description: FieldType<string, null>;
  invoke_dbt_agent: FieldType<boolean, null>;
  additional_kwargs: DBTQuerySelectionKwargs;
}

export interface DBTCommitModelsData {
  approval_status: FieldType<boolean, null>;
  convention_description: FieldType<string, null>;
  name_for_file_and_source_table: FieldType<Record<string, string>, Record<string, string>>;
  additional_kwargs: DBTCommitModelsKwargs;
}

// Union type for all DBT config types
export type DBTConfigData =
  | DBTGithubConfigData
  | DBTQuerySelectionData
  | DBTCommitModelsData;
